import {
  TcoVehicleVM,
  financialEvaluationVehicleTypeOptions,
  TcoCalculationsV2VM,
  TcoVehicleType,
} from '@optimization/sa-common';
import { roundTo } from '@optimization/ssi-common';
import { FormValues } from '..';

export const financeOptions = [
  { value: 'Leasing', name: 'Leasing' },
  { value: 'Cash', name: 'Cash' },
];

export const convertFormValuesToResponse = (vehicle: TcoVehicleVM, formValues: FormValues, isMultiple: boolean) => {
  const response: TcoCalculationsV2VM = {
    Currency: formValues.currency,
    ShowInPresentationApp: vehicle.TcoCalculations?.ShowInPresentationApp ?? true,
    YearsOfOwnership: roundTo(convertStringToNumber(formValues.yearsOfOwnership), 2),
    BevVehicle: {
      EngineType: TcoVehicleType[TcoVehicleType.Bev],
      FinancingType: financeOptions.find((x) => x.value === formValues.bevFinanceType)!.value,
      VehiclePrice: convertStringToNumber(formValues.bevVehiclePrice),
      InterestRate: convertStringToNumber(formValues.bevInterestRate),
      ResidualValue: convertStringToNumber(formValues.bevResidual),
      GovernmentSubsidies: convertStringToNumber(formValues.bevGovernmentSubsidies),
      EnergyCost: convertStringToNumber(formValues.bevEnergyCost),
      EnergyConsumption: isMultiple ? 0 : vehicle.TotalEc,
      InsurancePerMonth: convertStringToNumber(formValues.bevInsuranceCost),
      RoadTollPerMonth: convertStringToNumber(formValues.bevRoadToll),
      TaxPerMonth: convertStringToNumber(formValues.bevTaxesCost),
      MonthlyMaintenance: convertStringToNumber(formValues.bevMaintenanceCost),
    },
    ComparisonVehicle: {
      EngineType: financialEvaluationVehicleTypeOptions.find((x) => x.value === formValues.comparisonEngineType)!.value,
      FinancingType: financeOptions.find((x) => x.value === formValues.comparisonFinanceType)!.value,
      VehiclePrice: convertStringToNumber(formValues.comparisonVehiclePrice),
      InterestRate: convertStringToNumber(formValues.comparisonInterestRate),
      ResidualValue: convertStringToNumber(formValues.comparisonResidual),
      GovernmentSubsidies: convertStringToNumber(formValues.comparisonGovernmentSubsidies),
      EnergyCost: convertStringToNumber(formValues.comparisonEnergyCost),
      EnergyConsumption: convertStringToNumber(formValues.comparisonEnergyConsumption),
      AdBlueCost: convertStringToNumber(formValues.comparisonAdBlueCost),
      AdBlueConsumption: convertStringToNumber(formValues.comparisonAdBlueConsumption),
      InsurancePerMonth: convertStringToNumber(formValues.comparisonInsuranceCost),
      RoadTollPerMonth: convertStringToNumber(formValues.comparisonRoadtoll),
      TaxPerMonth: convertStringToNumber(formValues.comparisonTaxesCost),
      MonthlyMaintenance: convertStringToNumber(formValues.comparisonMaintenanceCost),
    },
  };

  if (response.ComparisonVehicle?.VehiclePrice === 0) response.ComparisonVehicle = undefined;

  return response;
};

export const convertStringToNumber = (formValue: string) => {
  const numberValue = Number(formValue);
  if (isNaN(numberValue) || formValue === '') return 0;

  return numberValue;
};
